import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FilesService } from '../../../core/services/files.service';
import { SupplierService } from '../../../core/services/supplier.service';
import { NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { NzMessageService } from 'ng-zorro-antd/message';

const SUPPLIERS_PAYMENT_UPLOAD = 'SUPPLIERS_PAYMENT_UPLOAD';

@Component({
  selector: 'app-add-supplier-popup',
  templateUrl: './add-supplier-popup.component.html',
  styleUrls: ['./add-supplier-popup.component.scss'],
})
export class AddSupplierPopupComponent {
  @Output() addEditSupplierOnChange: EventEmitter<any> = new EventEmitter();
  @Input() isVisible = false;
  suppliersForm: FormGroup | any;
  formErrors: any;
  paymentFiles: any[] = [];
  breadcrumbs: any[] = [];
  emailExists = false;
  supplierData = {
    paymentAttachment: [
      {
        name: '',
        url: '',
      },
    ],
    supplierDetails: {
      name: '',
      email: '',
      mobileNo: '',
    },
    paymentDetails: {
      accountNo: '',
      accountType: '',
      bankName: '',
      branch: '',
      holderName: '',
    },
  };
  prevPage = '';
  paymentFilesUploading = false;

  constructor(
    private fb: FormBuilder,
    private filesService: FilesService,
    private supplierService: SupplierService,
    private message: NzMessageService,
  ) {}

  ngOnInit(): void {
    this.initSupplierForm();
    this.paymentFiles = [];
  }

  initSupplierForm(): void {
    this.suppliersForm = this.fb.group({
      supplierDetails: this.fb.group({
        name: [
          null,
          [
            Validators.required,
            Validators.maxLength(70),
            Validators.pattern(/^[a-zA-Z\s]*$/),
          ],
        ],
        mobileNo: [
          null,
          [
            Validators.required,
            Validators.maxLength(15),
            Validators.pattern(/^\d+$/),
          ],
        ],
        email: [
          null,
          [Validators.required, Validators.maxLength(100), Validators.email],
        ],
      }),
      paymentDetails: this.fb.group({
        bankName: [null],
        branch: [null],
        accountType: [null],
        holderName: [
          this.supplierData.supplierDetails.name,
          [Validators.maxLength(70), Validators.pattern(/^[a-zA-Z\s]*$/)],
        ],
        accountNo: [
          null,
          [Validators.maxLength(70), Validators.pattern(/^\d+$/)],
        ],
      }),
      notes: this.fb.group({
        note: [null, [Validators.maxLength(200)]],
      }),
    });
  }

  initFormErrors() {
    this.formErrors = {
      supplierDetails: {
        name: {},
        mobileNo: {},
        email: {},
      },
      paymentDetails: {
        bankName: {},
        branch: {},
        accountType: {},
        holderName: {},
        accountNo: {},
      },
      notes: {
        note: {},
      },
    };
  }

  paymentFilesUpload(): void {
    this.paymentFilesUploading = true;
  }

  upload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(item.file, SUPPLIERS_PAYMENT_UPLOAD)
      .subscribe((res) => {
        const data = res as any;
        this.paymentFiles.push({ name: data.name, url: data.url });
        this.paymentFilesUploading = false;
      });

  onSubmit(): void {
    if (this.suppliersForm.valid) {
      this.supplierService
        .getSupplierByEmail({
          email: this.suppliersForm.get('supplierDetails.email').value,
        })
        .then((res) => {
          if (res) {
            this.message.create('warning', `Email is already existing!`);
            this.emailExists = true;
          } else {
            this.supplierService
              .createSupplier({
                ...this.suppliersForm.value,
                paymentAttachment: this.paymentFiles,
              })
              .then(() => {
                this.suppliersForm.reset();
                this.paymentFiles = [];
                this.isVisible = false;
                this.addEditSupplierOnChange.emit({
                  name: 'created',
                  value: false,
                });
              });
          }
        });
    } else {
      this.markFormGroupAsTouched(this.suppliersForm);
    }
  }

  markFormGroupAsTouched(formGroup: FormGroup): void {
    Object.values(formGroup.controls).forEach((control: any) => {
      control.markAsTouched();

      if (control instanceof FormGroup) {
        this.markFormGroupAsTouched(control);
      }
    });
  }

  cancel(): void {}

  confirm(): void {
    this.isVisible = false;
    this.addEditSupplierOnChange.emit({ name: 'isVisible', value: false });
  }

  confirmRemoveAttachment(attachmentId: any): void {
    this.paymentFiles.splice(attachmentId, 1);
  }

  updateAccountHolderName() {
    this.suppliersForm
      .get('paymentDetails.holderName')
      .setValue(this.suppliersForm.get('supplierDetails.name').value);
  }

  handleCancel(): void {
    this.isVisible = false;
    this.addEditSupplierOnChange.emit({ name: 'isVisible', value: false });
  }

  handleOk(): void {}
}
